// test1642
(1642 && 0);
